import React from 'react';
import SearchBar from '../components/SearchBar';
import ToolCard from '../components/ToolCard';
import toolRegistry from '../data/toolRegistry.json';
import './Home.css';

const Home = () => {
  const featuredTools = toolRegistry.tools.filter(tool => tool.featured);

  return (
    <div className="home">
      <section className="hero">
        <h1 className="hero-title">React Tools</h1>
        <p className="hero-subtitle">
          Free online tools for developers. Convert, format, and transform data right in your browser.
        </p>
        <SearchBar />
      </section>

      <section className="featured-section">
        <div className="section-header">
          <h2 className="section-title">Featured Tools</h2>
          <p className="section-description">
            Popular tools to help you with everyday development tasks
          </p>
        </div>
        <div className="tools-grid">
          {featuredTools.map(tool => (
            <ToolCard key={tool.id} tool={tool} />
          ))}
        </div>
      </section>

      <section className="all-tools-cta">
        <p>Looking for more?</p>
        <a href="/tools" className="cta-link">
          Browse all {toolRegistry.tools.length} tools →
        </a>
      </section>
    </div>
  );
};

export default Home;
